scriptscript<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
    <!--  <v-tour name="myTour" :steps="steps"></v-tour> -->
  </div>
</template>

<script>
import { Tooltip } from 'bootstrap';
import { mapActions } from 'vuex';

const tooltip = new Tooltip(document.body, {
  selector: "[data-bs-toggle='tooltip']",
});

export default {
  name: 'app',
  data: () => ({
    steps: [
      {
        target: '#v-step-0', // We're using document.querySelector() under the hood
        header: {
          title: 'Dashboard',
        },
        content: `This is your dashboard here you will find....`,
        params: {
          placement: 'right',
        },
      },
      {
        target: '.v-step-1',
        content: 'An awesome plugin made with Vue.js!',
      },
      {
        target: '[data-v-step="2"]',
        content:
          "Try it, you'll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.",
        params: {
          placement: 'top', // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
  }),
  methods: {
    ...mapActions(['refreshToken', 'retrieveAllCountries', 'retrieveLanguagesList']),
  },
  mounted() {
    /* this.$tours['myTour'].start(); */

    tooltip.show();

    this.retrieveAllCountries();
    this.retrieveLanguagesList();
  },
  beforeDestroy() {
    tooltip.dispose();
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';
@import '@/assets/scss/_variables.scss';
@import 'vue-select/src/scss/vue-select.scss';
@import '../../node_modules/vue-tour/dist/vue-tour.css';

/* Funnel css */
.label__value {
  display: none;
}

.svg-funnel-js__labels .svg-funnel-js__label .label__title {
  margin-left: -20px !important;
}

/* End Funnel css */

/* Include Filter */

/* Tooltip popper */
.popper {
  background-color: rgba($color: rgb(255, 255, 255), $alpha: 0.9) !important;
  border: 1px solid rgba($color: rgb(226, 226, 226), $alpha: 0.9);
  border-radius: 6px;
  box-shadow: none !important;
}

.fa-stack {
  color: #666 !important;
  font-size: 14px;

  .fas {
    color: #666 !important;
  }

  & i:hover {
    cursor: pointer !important;
  }

  .is-clicked {
    color: #f05a00 !important;
  }

  .is-clicked:hover {
    color: #ff741e !important;
  }
}
/* End Include Filter */

.owl-stage {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 576px) {
  .owl-dots {
    display: none;
  }
}

/* v-search global css */
#add-job-competences,
#location,
#sources-select,
#employer-select,
#manager-jobs-select,
#service-level-select,
#service-level-single-job,
#published-promoted-select,
#sources-select-chart-two,
#sources-select-funnel-two,
#select-jobs,
#sources-select-funnel-two {
  min-height: 28px;
}

.existing-candidate {
  .v-select {
    .vs__dropdown-toggle {
      height: 3rem;
    }
  }
}

.filter-item {
  .vs--unsearchable {
    span {
      margin-top: 15px;
      font-size: 1rem;
    }
  }
  .vs--searchable .vs__dropdown-toggle {
    min-height: 3rem;
  }

  .vs__open-indicator {
    margin-top: 0 !important;
  }
}

/* Hide floating labal when select menu is open */
/* .vs--open {
  .vs__selected {
    visibility: hidden;
  }
} */

.vs__open-indicator {
  content: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>");
}

/* .has-floating-label input[type]:not(:placeholder-shown),
.has-floating-label .select-style:not(:placeholder-shown) {
  padding-top: 1.3rem;
} */

.vs__search::-webkit-input-placeholder {
  color: #777;
}

/* 

.vs__selected {
  padding-top: 1rem !important;
  font-size: 1rem !important;
}
*/
/*
.vs--searchable, .filter-item .vs__dropdown-toggle {
  min-height: 3rem;

  ::placeholder {
    font-family: $font-family-sans-lato;
    font-size: 16px;
  }
} */

.filter-items {
  .vs__dropdown-toggle {
    min-height: 38px;
    color: #6c757d;
  }
}

/* .vs__actions {
  .vs__open-indicator {
    display: none;
  }

  &::after {
    content: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>");
  }
} */

/* =====================
      POPPER STYLES
=======================*/
.popper {
  box-shadow: 0 12px 13px #00000033;
  -webkit-box-shadow: 0 2px 3px #00000033;
  padding: 7px;
  background-color: #fff;
  font-family: $font-family-sans-lato;
}

/* =====================
      VUE-TOUR STYLES
=======================*/
.v-step {
  background: #fff !important;
  color: #777 !important;
  .v-step__header {
    font-family: $font-family-sans-serif;
    font-weight: 700;
    background-color: #f1f1f1 !important;
    border-bottom: 1px solid #ddd;
    color: #222 !important;
  }
  .v-step__content {
    font-family: $font-family-sans-lato;
  }
  .v-step__button {
    border-radius: 5px !important;
    padding: 6px 10px !important;
    &:hover {
      color: #fff !important;
    }
  }
  .v-step__button-next {
    background: $btn-primary-hover-color-orange !important;
    border: 1px solid $btn-primary-hover-color-orange !important;
    &:hover {
      background: $color-orange !important;
    }
  }
  .v-step__button-skip {
    background: $color-status-pipeline-contacted !important;
    border: 1px solid $btn-primary-hover-color-blue !important;
    &:hover {
      background: $color-base-blue !important;
    }
  }
}
.vs__dropdown-toggle {
  background: #fff;
}
</style>
